import { StyleSheet } from "aphrodite";

const Style = StyleSheet.create({
  gridItemStyle: {
    "@media (max-width: 768px)": {
      gridColumn: "1 / 3",
    },
  },
  buttonDivStyle: {
    "@media (max-width: 768px)": {
      width: "98%",
    },
  },
  mainBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
});

export default Style;
